module.exports = __webpack_public_path__ + "static/media/user.b76a5002.jpg";